<template>
  <div class="cencel">
    <el-dialog :visible.sync="dialogVisible" width="100%" autofocus="fasle" :close="close" :before-close="close"
      :close-on-press-escape="closeModal" :close-on-click-modal="closeModal" :show-close="showClose">
      <div class="title">{{$t('common.cencel_dialog.check_info')}}</div>
      <div class="tip">{{getTypeTip(type)}}</div>
      <div class="preview-btn">
        <div class="sub-tipsub--btn">
          <el-button @click="submit" v-loading="loading" :disabled="loading" class="submit">{{$t('common.ok')}}</el-button>
        </div>
        <div class="sub-tipsub-btn">
          <el-button @click="close" class="edit" :disabled="loading">{{$t('common.cancel')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: ['dialogVisible', 'params', 'type', 'handle', 'loading', 'closeModal', 'currency'],
    data() {
      return {
        showClose: false
      }
    },
    methods: {
      submit() {
        this.handle()
      },
      close(e) {
        this.$emit('update:dialogVisible', false)
        this.$emit('update:loading', false)
      },
      getTypeTip(key) {
        let items = this.$t('common.cencel_dialog.tip')
        return items[key] ? items[key] : key
      },
      getKey(key) {
        let items = this.$t('common.cencel_dialog')
        return items[key] ? items[key] : key
      }
    }
  }

</script>

<style lang="scss">
  .cencel {
    .el-dialog {
      max-width: 500px;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 43px 49px 43px;
    }

    .title {
      font-family: 'Muli-Bold';
      font-weight: bold;
      color: #24282d;
      font-size: 22px;
      border-bottom: 3px solid #e2e2e2;
      padding-bottom: 12px;
      margin-bottom: 20px;
    }

    .tip {
      font-size: 16px;
      color: #24282d;
      font-weight: bold;
      font-family: 'Muli-Bold';
      padding-top: 0;
    }

    .data {
      clear: none;
      height: 20px;
      border-bottom: 1px solid #e2e2e2;
      padding: 8px 0;

      .data-left {
        float: left;
        color: #7d7d7d;
        font-family: 'PingFangTC-Medium';
        font-size: 12px;
      }

      .data-right {
        float: right;
        font-size: 14px;
        color: #24282d;
        font-family: 'PingFangTC-Medium';
      }
    }

    .preview-btn {
    }

    .sub-tipsub--btn {
      text-align: center;
      width: 100%;
      padding-top: 10px;

      .el-button {
        margin-top: 20px;
        width: 100%;
        color: #192b57;
        font-weight: bold;
        height: 56px;
        border-color: #ffe080;
        background-color: #fecd33;
        max-width: 250px;
      }

      .el-button--primary:hover,
      .el-button--primary:focus {
        border-color: #fecd33;
        background-color: #fecd33;
        color: #192b57;
      }

      .el-button--primary span {
        font-family: Muli-Bold;
        font-size: 14px;
        color: #193060;
        letter-spacing: 0.17px;
      }
    }

    .sub-tipsub-btn {
      width: 100%;
      text-align: center;
      .el-button {
        width: 250px;
        max-width: 248.9px;
        border: 1px solid #193060;
        margin-top: 20px;
        font-family: Muli-Bold;
        font-size: 14px;
        color: #193060;
        height: 56px !important;
      }

      .submit {
        border: 0;
        color: #000;
        background-color: #fec000;

        &:hover {
          height: 38px;
          border: 1px solid #e0e6f5;
          color: #000 !important;
          background-color: #fff !important;
        }
      }
    }
  }

</style>
